// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'bill_no',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'user',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'status',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'total_amount',
    Object: 'value',
    label: '',
    width: '120'
  }, {
    prop: 'total_due',
    Object: 'value',
    label: '',
    width: '150'
  }, {
    prop: 'due_date',
    label: '',
    Object: 'value',
    width: '120'
  }]
}
